<template>
  <a
    class="custom-link"
    href="https://app.pwn.xyz"
    target="_blank">
    <div class="primary-btn responsive enter-pwn-btn">Enter PWN</div>
  </a>
</template>

<style scoped>
.custom-link {
  display: flex;
  justify-content: center;
}

.enter-pwn-btn.primary-btn {
  padding: 8px 24px;
}

/*/////// Mobile ///////*/

@media (max-width: 1100px) {
  .responsive {
    display: flex;
    justify-content: center;
    width: 100%;
    max-width: 450px;
    text-align: center;
  }

  .custom-link {
    width: 100%;
    justify-content: center;
  }
}
</style>
